<div class="empty-list">
    <app-icon-thumbnail [icon]="icon" [height]="(isDesktop$ | async) ? 150 : 75" class="mb-3"></app-icon-thumbnail>
    <p class="title">{{ title }}</p>
    <p class="description">{{ emptyText }}</p>
</div>

